<template>
  <a-modal v-model="modal" title="修改" width="500px" :maskClosable="false" :closable="false">
    <a-form-model
      :model="formData"
      ref="form"
    >
      <a-form-model-item
        label="组件物料"
        :labelCol="{ style: 'width: 100px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 100px ) !important;float:left'}"
        prop="roItemCode"
        :rules="rules.roItemCode"
        v-if="fieldType==='roItemCode'"
      >
        <global-select
          :value.sync="formData.roItemCode"
          selectType="selectSearch"
          :dropdown-match-select-width="false"
          requestApi="/mdm/mdmItemSystemItem/itemCodeBox"
          :selectItem="{ value: 'realValue', label: 'label' }"
          searchParam="itemCode"
          sourseField="res"
          :totalNum="9999999999"
        />
      </a-form-model-item>
      <a-form-model-item
        label="用量"
        :labelCol="{ style: 'width: 80px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 80px ) !important;float:left'}"
        prop="quantityPerAssembly"
        :rules="rules.quantityPerAssembly"
        v-if="fieldType==='quantityPerAssembly'"
      >
        <a-input-number
          style="width: 100%"
          v-model="formData.quantityPerAssembly"
          :min="0"
          :formatter="(value) => `${value}`.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
          :parser="(value) => value.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
        />
      </a-form-model-item>
    </a-form-model>
    <template #footer>
      <a-space>
        <a-button :loading="loading" @click="modal=false;$refs.form.resetFields();">取消</a-button>
        <a-button type="primary" @click="submit" :loading="loading">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import { apiMesEditMaterial, apiMesEditQuantityPerAssembly } from '@/api/mes/workOrderManage/workOrderDesk'
import moment from 'moment';
import cloneDeep from 'lodash.clonedeep'

export default {
  name: 'UpdateMaterialModal',
  data() {
    return {
      fieldType: '', // 修改字段标识
      modal: false,
      item: {}, // 数据
      formData: {},
      loading: false,
      rules: {
        roItemCode: [{ required: true, message: ' ', trigger: 'change' }],
        quantityPerAssembly: [{ required: true, message: ' ', trigger: 'blur' }]
      },
      selectedRows: []
    }
  },
  methods: {
    moment,
    show (item, field) {
      this.fieldType = field // 区分修改字段标识
      this.item = cloneDeep(item)
      this.$set(this.formData, this.fieldType, this.item[this.fieldType])
      this.modal = true
    },
    submit () {
      this.$refs.form.validate(valid => {
        if(valid) {
          const api = this.fieldType === 'roItemCode' ? apiMesEditMaterial : apiMesEditQuantityPerAssembly
          const params = {
            id: this.item.id
          }
          if (this.fieldType === 'roItemCode') {
            params.newItemId = this.formData.roItemCode
          } else {
            params.quantityPerAssembly = this.formData.quantityPerAssembly
          }
          this.loading = true
          api(params).then(response => {
            if (response?.code === 200) {
              this.modal = false
              this.$message.success('修改完成!')
              this.$emit("handle-success")
            } else {
              this.$message.error(response.msg)
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
